import { Injectable } from '@angular/core';
import { randomUuid } from './uuid.util';

const STORAGE_KEY = 'polpaico_session_id';

@Injectable({ providedIn: 'root' })
export class SessionIdService {
  private cached: string | null = null;

  /** Genera y persiste un nuevo sessionId (login exitoso). */
  createSessionId(): string {
    const id = randomUuid();
    try {
      sessionStorage.setItem(STORAGE_KEY, id);
      this.cached = id;
    } catch {
      this.cached = id;
    }
    return id;
  }

  getSessionId(): string | null {
    if (this.cached) {
      return this.cached;
    }
    try {
      const id = sessionStorage.getItem(STORAGE_KEY);
      if (id) {
        this.cached = id;
      }
      return id;
    } catch {
      return null;
    }
  }

  clearSessionId(): void {
    this.cached = null;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }
}
